var React = require('react');

function LastUpdated (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 22c5.523 0 10-4.477 10-10S18.523 2 13 2 3 6.477 3 12H1l3 4 3-4H5a8 8 0 1 1 2.799 6.078c-.49-.42-1.266-.377-1.624.16-.252.377-.212.881.124 1.185A9.963 9.963 0 0 0 13 22zm1-14a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-2V8z","fill":"#fff"}));
}

LastUpdated.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LastUpdated;

LastUpdated.default = LastUpdated;
